import { useMutation } from '@tanstack/react-query';
import { AuthApiError } from '@supabase/supabase-js';

import { supabaseClient } from 'src/auth/supabase';

export const useVerifyOtpSupabase = () =>
    useMutation<void, AuthApiError, { email: string; token: string }>({
        mutationKey: ['auth', 'otp', 'verify'],
        mutationFn: async ({ email, token }) => {
            const res = await supabaseClient.auth.verifyOtp({
                type: 'email',
                email,
                token,
            });

            if (res.error) throw res.error;
        },
    });
